// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as PorterStoreStrings from "../PorterStoreStrings.bs.js";

function PorterStoreDownloadModal(Props) {
  var isOpen = Props.isOpen;
  var onClose = Props.onClose;
  var onDownload = Props.onDownload;
  return React.createElement(ReactModal, {
              isOpen: isOpen,
              onRequestClose: (function (param) {
                  return Curry._1(onClose, undefined);
                }),
              overlayClassName: "ps_modal-overlay",
              className: "ps-download-modal-layout",
              shouldCloseOnOverlayClick: true,
              children: React.createElement("div", {
                    className: "ps-download-modal"
                  }, React.createElement("div", {
                        className: "ps-download-modal__content"
                      }, React.createElement("h3", {
                            className: "ps-download-modal__title"
                          }, PorterStoreStrings.downloadModalTitle), React.createElement("p", {
                            className: "ps-download-modal__desc"
                          }, PorterStoreStrings.downloadModalDesc)), React.createElement("div", {
                        className: "ps-download-modal__footer"
                      }, React.createElement("button", {
                            className: "ps-download-modal__cancel-btn",
                            onClick: (function (param) {
                                return Curry._1(onClose, undefined);
                              })
                          }, PorterStoreStrings.downloadModalCancel), React.createElement("button", {
                            className: "ps-download-modal__download-btn",
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                                setTimeout((function (param) {
                                        return Curry._1(onDownload, undefined);
                                      }), 100);
                                
                              })
                          }, PorterStoreStrings.downloadModalDownload)))
            });
}

var make = PorterStoreDownloadModal;

export {
  make ,
  
}
/* react Not a pure module */
